export default __webpack_public_path__ + "static/media/the-head-and-the-heart.3d51bd15.jpg";